<template>
  <div>
    <v-container >
      <v-app-bar app color="primary" dark >
        <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
        <v-toolbar-title v-text="$store.state.pageTitle"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark class='primary darken-2' icon @click="$router.push('/order')">
          <v-icon >mdi-plus</v-icon>
        </v-btn>
      </v-app-bar>

      <v-data-table
        :headers="headers"
        :items="orders"
        :items-per-page="15"
        class="elevation-1"
      >
        <template v-slot:item.date="{ item }">
          {{ $moment(item.date).format('L') }}
        </template>
        <template v-slot:item.amount="{ item }">
          {{ $toMoney(item.amount) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn icon class="mr-3" @click="editOrder(item)">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="deleteOrder(item.id)">
            <v-icon color="warning">mdi-delete</v-icon>
          </v-btn>
        </template>

      </v-data-table>
    </v-container>


    <v-dialog v-model="dialogUser" scrollable fullscreen  persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card v-if="user.id">
        <v-card-title primary-title>
          {{ dialogUserTitle }} <v-spacer></v-spacer> <v-btn color="black" icon @click="closeDialogUser"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Name" v-model="user.UserProfile.name"></v-text-field>
          <v-text-field label="Phone" v-model="user.UserProfile.phone"></v-text-field>
          <v-text-field label="Email" v-model="user.email"></v-text-field>
          <v-text-field label="Address" v-model="user.UserProfile.address"></v-text-field>
          <v-autocomplete :loading="isLoading" :items= "$store.state.cities" v-model="user.UserProfile.city" return-object item-text="city" item-value="city" label="City" hide-no-data hide-selected></v-autocomplete>
          <v-text-field label="Post Code" v-model="user.UserProfile.postCode"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="saveUser">{{ dialogUserBtn }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

  export default {
    data(){
      return {
        dialogOrder: false,
        dialogUser: false,
        orders: [],
        order: { orderItem: {} },
        userOrder: {},
        user: {},
        headers:[
          { text: 'Date', value: 'date', sortable: false },
          { text: 'Name', value: 'User.UserProfile.name', sortable: false },
          { text: 'Amount', value: 'amount', align: 'end', sortable: false },
          { text: 'Action', value: 'action', align: 'end', sortable: false },
        ]
      }
    },
    created(){
      this.getOrders();
    },
    computed:{

      dialogOrderTitle(){
        if(!this.dialogOrder) return '';
        return (!this.$route.params.id)  ? 'Add order' : 'Edit order';
      },
      dialogOrderBtn(){
        if(!this.dialogOrder) return '';
        return (!this.$route.params.id)  ? 'Save' : 'Update';
      },
      dialogUserTitle(){
        if(!this.dialogUser) return '';
        return (!this.user.id)  ? 'Add user' : 'Edit user';
      },
      dialogUserBtn(){
        if(!this.dialogUser) return '';
        return (!this.user.id)  ? 'Save' : 'Update';
      },
      filteredProducts(){
        return this.$store.state.products
      },
      filteredUsers(){
        return this.$store.state.users
      }
    },
    methods:{
      toggleDrawer(){
        this.$store.commit('mutate', { prop: 'drawer', data: !this.$store.state.drawer })
      },
      getOrders(){
        this.axios.get('/orders').then( (res) => {
          this.orders = res.data
        })
      },

      editOrder(item){
        this.$router.push('order/'+ item.id)
      },

      newOrder(){
        this.dialogOrder = true
        this.order.date = this.$moment().format(),
        this.status = 'draft'
      },

      closeDialogOrder(){
        this.dialogOrder = false
      },
      closeDialogUser(){
        this.dialogUser = false
      },

      createOrder(){
        this.axios.post('orders', this.order).then( (res) => {
          this.$store.commit('mutate', { prop: 'order', date: res.data })
          this.$router.push('/order/' + res.data.id)
        })
      },

      saveOrder(){
        if (!this.order.id){
          this.axios.post('/orders', this.order).then( () =>{
            this.getOrders()
            this.closeDialogOrder()
          })
        } else {
          console.log('')
        }
      },

      deleteOrder(id){
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.axios.delete('/orders/' + id).then( () => {
              this.getOrders()
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Deleted!', value:true } })
            })
          }
        })

      }


    }
  }
</script>

<style scoped>
</style>